<template>
  <div>
    <vxe-grid
      ref="docTable"
      size="mini"
      border
      resizable
      auto-resize
      highlight-hover-row
      :toolbar-config="tableToolbar"
      :data="tableData"
      :columns="tableColumns"
      :loading="loading"
    >
      <template v-slot:toolbar_form>
        <slot name="header"></slot>
      </template>
      <template v-slot:opt="{ row }">
        <div>
          <el-tooltip
            class="item"
            effect="dark"
            :content="$l('INDEX.btn_tips_downloada') || '下载'"
            placement="top"
          >
            <i class="el-icon-download tool-btn" @click="downloadFile(row)"></i>
          </el-tooltip>
          <el-tooltip
            v-if="!disabled && ['N', 'F'].includes(row.processFlag)"
            class="item"
            effect="dark"
            :content="$l('INDEX.btn_tips_del') || '删除'"
            placement="top"
          >
            <i class="el-icon-delete tool-btn" @click="del(row)"></i>
          </el-tooltip>
        </div>
      </template>
      <template v-slot:uploadInfo="{ row }">
        <span>{{ row.updatedByName }}</span>
        <br />
        <span>{{ row.updatedTime }}</span>
      </template>
      <template v-slot:processFlag="{ row }">
        <el-tag
          size="mini"
          :type="
            row.processFlag === 'Y'
              ? 'success'
              : row.processFlag === 'F'
              ? 'warning'
              : row.processFlag === 'K'
              ? 'info'
              : row.processFlag === 'D'
              ? 'danger'
              : ''
          "
        >
          {{ row.v_processFlag }}
        </el-tag>
      </template>
      <template v-slot:processMessage="{ row }">
        <div v-if="row.processMessage">
          <span v-if="!isJSONString(row.processMessage)">
            {{ row.processMessage }}
          </span>
          <span v-if="isJSONString(row.processMessage)">
            <el-button
              size="small"
              type="text"
              @click="openProcessMessage(row)"
            >
              {{ $l('btn_openProcessMessage') || '查看处理结果明细' }}
            </el-button>
          </span>
        </div>
      </template>
    </vxe-grid>

    <processMessage
      :visible.sync="processMessageOpts.visible"
      :data="processMessageOpts.data"
    />
  </div>
</template>
<script>
import tableColumns from './table-columns'
import EditLoading from '@/mixins/edit-loading'
import processMessage from '../process-message'
export default {
  mixins: [EditLoading],
  components: { processMessage },
  props: {
    loading: { type: Boolean, default: false },
    tableData: { type: Array, default: () => [] },
    disabled: { type: Boolean, default: false },
  },
  data() {
    return {
      tableToolbar: {
        slots: { buttons: 'toolbar_form' },
        refresh: { query: () => this.$emit('reload') },
        zoom: true,
        custom: true,
      },
      processMessageOpts: { visible: false, data: [] },
    }
  },
  computed: {
    tableColumns() {
      return tableColumns(this)
    },
  },
  methods: {
    downloadFile({ fileMd5 }) {
      this.$api.SYS_FILEDOWNLOAD(fileMd5)
    },
    async del({ fileCode }) {
      const confirm = await this.$confirm(
        this.$l('tips_delOrderFile') || '是否要删除该采购订单文件？',
        this.$l('INDEX.label_completeDesc') || '确认信息',
        {
          confirmButtonText:
            this.$l('INDEX.product_dialog_btn_confirm') || '确定',
          cancelButtonText: this.$l('INDEX.btn_cancel') || '取消',
          type: 'warning',
        }
      )
        .then(() => true)
        .catch(() => false)
      if (!confirm) return

      if (this.loadingOpen()) return

      const res = await this.$api
        .ecomAmzVcOrderFilesDelApi({ fileCode })
        .catch(() => null)
      this.loadingClose()
      if (!res) return
      const { status } = res
      if (status !== 200) {
        this.$message.error(this.$l('INDEX.tips_delete_no') || '删除失败！')
        return
      }
      this.$message({
        showClose: true,
        message: this.$l('INDEX.tips_delete_ok') || '删除成功！',
        type: 'success',
      })
      this.$emit('reload')
    },
    isJSONString(str) {
      if (!str) return false
      try {
        JSON.parse(str)
        return true
      } catch (e) {
        return false
      }
    },
    openProcessMessage({ processMessage }) {
      if (!this.isJSONString(processMessage)) return
      this.processMessageOpts = {
        visible: true,
        data: JSON.parse(processMessage).sort((a, b) => a.rowNum - b.rowNum),
      }
    },
  },
}
</script>
